import React from 'react'

import * as S from './WeightedShipping.styled'

export const WeightedShipping = () => {
  return (
    <S.Description>
      We'll do our best to estimate the cost of shipping for a customer's order based on the weight
      of their order.
    </S.Description>
  )
}
